import { PlayerAsset } from 'types/Player';
import { UpdateDevicePayload } from 'types/CommonTypes';
import { FetchResponse } from 'types/ApiTypes';

export abstract class IDRM {
    abstract handleWidevine: () => void;

    abstract handlePlayReady: () => void;

    abstract detectSupport: () => void;

    abstract getConfiguration: (asset: PlayerAsset) => any;

    abstract getAdditionalConfiguration: (asset: PlayerAsset) => Promise<{ [key: string]: any }>;

    abstract getHeaders: (asset: PlayerAsset) => void;

    abstract getRequestFilter: (type, request, asset: PlayerAsset) => void;

    abstract getResponseFilter: (type, response) => void;

    abstract getDRMType: () => string;

    abstract configurePlayer: (playerInstance: any, asset: PlayerAsset) => any;

    abstract init: (updateDevice: (deviceUuid: string, payload: UpdateDevicePayload) => Promise<FetchResponse<any>>) => void;
}
